import * as React from "react";
const SvgFiRrHeadVr = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-head-vr_svg__a)">
      <path
        fill="#062147"
        d="M21 5h-.773a9 9 0 0 0-.427-.58C17.364 1.163 13.487-.45 9.454.105 4.457.793.501 4.946.046 9.982c-.25 2.77.536 5.501 2.215 7.691.477.624.74 1.46.74 2.355V21c0 1.654 1.345 3 3 3h7c1.654 0 3-1.346 3-3h.493a5.015 5.015 0 0 0 4.958-4.345l.068-.524a1 1 0 1 0-1.982-.262l-.069.523a3.01 3.01 0 0 1-2.975 2.607h-1.493a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-.97c0-1.333-.41-2.602-1.152-3.572a9 9 0 0 1-1.81-6.296l.015-.162h8.073a4.006 4.006 0 0 0 3.874 3h7c1.653 0 3-1.346 3-3v-2c0-1.654-1.347-3-3-3zM9.725 2.088c3.033-.42 5.948.656 7.967 2.912h-3.691a4.006 4.006 0 0 0-3.874 3H2.513c1.101-3.097 3.872-5.453 7.211-5.912zM22.001 10a1 1 0 0 1-1 1h-7c-1.103 0-2-.897-2-2s.897-2 2-2h7a1 1 0 0 1 1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-head-vr_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHeadVr;
